import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import IdentificationFields, { emptyIdent, identError } from "@/components/IdentificationFields";

export default function CompleteIdentificationDialog({ customerId, open, onOpenChange, onSaved }) {
  const [ident, setIdent] = useState(emptyIdent);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    const err = identError(ident);
    if (err) return toast.error(err);
    setBusy(true);
    try {
      await api.patch(`/customers/${customerId}`, ident);
      toast.success("Identification recorded");
      setIdent(emptyIdent);
      onOpenChange(false);
      onSaved?.();
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not save identification");
    } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="complete-ident-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Complete identification</DialogTitle>
          <DialogDescription>Saint Herb membership requires an ID type and number on every customer profile.</DialogDescription>
        </DialogHeader>
        <IdentificationFields value={ident} onChange={setIdent} testidPrefix="complete" />
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={save} disabled={busy} className="rounded-full" data-testid="complete-ident-save">
            {busy ? "Saving…" : "Save identification"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
